// THIS FILE IS AUTO GENERATED - do not edit!

import { forwardRef, type JSX } from 'react';

import { SvgIcon, type SvgIconProps } from '../lib/SvgIcon.js';

const ZoomHorizontalIconComponent = /* @__PURE__ */ forwardRef<
  SVGSVGElement,
  SvgIconProps
>((props: SvgIconProps, forwardedRef): JSX.Element => {
  return (
    <SvgIcon data-iconname="ZoomHorizontalIcon" ref={forwardedRef} {...props}>
      <path d="M10 14a5 5 0 0 0 2.172-.495l2.742 2.733a1.005 1.005 0 0 0 1.418-.001 1 1 0 0 0 .001-1.413l-2.556-2.548A5 5 0 1 0 10 14m0-1.5a3.5 3.5 0 1 1 0-7 3.5 3.5 0 0 1 0 7" />
      <path d="M2.828 11.828 0 9l2.828-2.828 1.063 1.062-1.77 1.77 1.766 1.765z" />
      <path d="M17.172 6.172 20 9l-2.828 2.828-1.063-1.062 1.77-1.77-1.766-1.765z" />
    </SvgIcon>
  );
});

/**
 * @public
 */
export const ZoomHorizontalIcon = /* @__PURE__ */ Object.assign(
  ZoomHorizontalIconComponent,
  { displayName: 'ZoomHorizontalIcon' },
);
